module.exports = __webpack_public_path__ + "static/images/envelope-outline.2dc6927bb1dc4866206ea8d47f3d65d3.svg";